<template>
  <div>
    <div class="vs-row">
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Default</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-card>
              <div slot="header">
                <h3>Hello world !</h3>
              </div>
              <div>
                <span
                  >Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.</span
                >
              </div>
              <div slot="footer">
                <vs-row vs-justify="flex-end">
                  <vs-button
                    class="mr-1"
                    type="gradient"
                    color="danger"
                    icon="favorite"
                  ></vs-button>
                  <vs-button
                    class="mr-1"
                    color="primary"
                    icon="turned_in_not"
                  ></vs-button>
                  <vs-button
                    class="mr-1"
                    color="rgb(230,230,230)"
                    color-text="rgb(50,50,50)"
                    icon="settings"
                  ></vs-button>
                </vs-row>
              </div>
            </vs-card>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="6" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Default</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-card>
              <div slot="header">
                <h3>Hello world !</h3>
              </div>
              <div>
                <span
                  >Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt ut labore et dolore magna aliqua.
                  Ut enim ad minim veniam, quis nostrud exercitation ullamco
                  laboris nisi ut aliquip ex ea commodo consequat.</span
                >
              </div>
              <div slot="footer">
                <vs-row vs-justify="flex-end">
                  <vs-button
                    class="mr-1"
                    type="gradient"
                    color="danger"
                    icon="favorite"
                  ></vs-button>
                  <vs-button
                    class="mr-1"
                    color="primary"
                    icon="turned_in_not"
                  ></vs-button>
                  <vs-button
                    class="mr-1"
                    color="rgb(230,230,230)"
                    color-text="rgb(50,50,50)"
                    icon="settings"
                  ></vs-button>
                </vs-row>
              </div>
            </vs-card>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Media</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-row vs-justify="center">
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <vs-card class="cardx">
                  <div slot="header">
                    <h3>Hello world !</h3>
                  </div>
                  <div slot="media">
                    <img src="@/assets/images/card.png" />
                  </div>
                  <div>
                    <span
                      >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo
                      consequat.</span
                    >
                  </div>
                  <div slot="footer">
                    <vs-row vs-justify="flex-end">
                      <vs-button
                        type="gradient"
                        class="mr-1"
                        color="danger"
                        icon="favorite"
                      ></vs-button>
                      <vs-button
                        class="mr-1"
                        color="primary"
                        icon="turned_in_not"
                      ></vs-button>
                      <vs-button
                        color="rgb(230,230,230)"
                        color-text="rgb(50,50,50)"
                        icon="settings"
                      ></vs-button>
                    </vs-row>
                  </div>
                </vs-card>
              </vs-col>
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <vs-card class="cardx">
                  <div slot="header">
                    <h3>Hello world !</h3>
                  </div>
                  <div slot="media">
                    <img src="@/assets/images/card2.png" />
                  </div>
                  <div>
                    <span
                      >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo
                      consequat.</span
                    >
                  </div>
                  <div slot="footer">
                    <vs-row vs-justify="flex-end">
                      <vs-button
                        class="mr-1"
                        type="gradient"
                        color="danger"
                        icon="favorite"
                      ></vs-button>
                      <vs-button
                        class="mr-1"
                        color="primary"
                        icon="turned_in_not"
                      ></vs-button>
                      <vs-button
                        color="rgb(230,230,230)"
                        color-text="rgb(50,50,50)"
                        icon="settings"
                      ></vs-button>
                    </vs-row>
                  </div>
                </vs-card>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vs-col>
      <vs-col vs-lg="12" vs-xs="12">
        <div class="con-vs-card cardx">
          <header class="vs-card--header">
            <div>
              <h6 class="font-medium">Hover</h6>
            </div>
          </header>
          <div class="vs-card--content">
            <vs-row vs-justify="center">
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <vs-card actionable class="cardx">
                  <div slot="header">
                    <h3>Hello world !</h3>
                  </div>
                  <div slot="media">
                    <img src="@/assets/images/card.png" />
                  </div>
                  <div>
                    <span
                      >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo
                      consequat.</span
                    >
                  </div>
                  <div slot="footer">
                    <vs-row vs-justify="flex-end">
                      <vs-button
                        type="gradient"
                        class="mr-1"
                        color="danger"
                        icon="favorite"
                      ></vs-button>
                      <vs-button
                        class="mr-1"
                        color="primary"
                        icon="turned_in_not"
                      ></vs-button>
                      <vs-button
                        color="rgb(230,230,230)"
                        color-text="rgb(50,50,50)"
                        icon="settings"
                      ></vs-button>
                    </vs-row>
                  </div>
                </vs-card>
              </vs-col>
              <vs-col
                type="flex"
                vs-justify="center"
                vs-align="center"
                vs-w="6"
              >
                <vs-card actionable class="cardx">
                  <div slot="header">
                    <h3>Hello world !</h3>
                  </div>
                  <div slot="media">
                    <img src="@/assets/images/card2.png" />
                  </div>
                  <div>
                    <span
                      >Lorem ipsum dolor sit amet, consectetur adipiscing elit,
                      sed do eiusmod tempor incididunt ut labore et dolore magna
                      aliqua. Ut enim ad minim veniam, quis nostrud exercitation
                      ullamco laboris nisi ut aliquip ex ea commodo
                      consequat.</span
                    >
                  </div>
                  <div slot="footer">
                    <vs-row vs-justify="flex-end">
                      <vs-button
                        class="mr-1"
                        type="gradient"
                        color="danger"
                        icon="favorite"
                      ></vs-button>
                      <vs-button
                        class="mr-1"
                        color="primary"
                        icon="turned_in_not"
                      ></vs-button>
                      <vs-button
                        color="rgb(230,230,230)"
                        color-text="rgb(50,50,50)"
                        icon="settings"
                      ></vs-button>
                    </vs-row>
                  </div>
                </vs-card>
              </vs-col>
            </vs-row>
          </div>
        </div>
      </vs-col>
    </div>
  </div>
</template>
<script>
export default {
  watch: {
    "$store.state.theme"(val) {
      this.chartTheme(val);
    },
  },
  methods: {
    chartTheme(val) {
      let mode = val == "dark" ? "dark" : "light";
      return mode;
    },
  },
  mounted() {
    this.chartTheme(this.$store.state.theme);
  },
  data: () => ({ colorx: "#c72a75", colorx2: "#5252e8" }),
};
</script>